const enGB = {
  locale: 'en-GB',
  productsAddedToBasket: {
    one: '1 product added to your basket',
    other: '{count} products added to your basket'
  },
  basketItems: {
    one: '1 item in your basket',
    other: '{count} items in your basket'
  },
  fakeStockItem: {
    one: '1 in stock on {date}',
    other: '{count} in stock on {date}'
  },
  productStockInStock: {
    one: '{count} in stock',
    other: '{count} in stock'
  },
  productStockDueStock: {
    one: '{count} Due: {date}',
    other: '{count} Due: {date}'
  },
  searchProductDueStock: {
    one: 'Stock due {date}',
    other: 'Stock due on {date}'
  },
  filterViewResults: {
    one: 'View {count} Result',
    other: 'View {count} Results'
  },
  bulkBuyPack: {
    one: '{count} pack',
    other: '{count} pack'
  }
};

export default enGB;
